import OperatorGetParamsQuestionCategoryOpenApiModel = OperatorApplicationApi.OperatorGetParamsQuestionCategoryOpenApiModel;
import {TreeItemInterface} from "~/core-ui/vue/ui/tree-select/Interface";

export default function siteQuestionCategoriesToTreeData(site: OperatorApplicationApi.OperatorGetParamsSiteOpenApiModel) {
    return questionCategoriesToTreeData(site.questionCategoriesTree);
}

export function questionCategoriesToTreeData(tree: OperatorGetParamsQuestionCategoryOpenApiModel[]) {
    let result = [];
    for (let category of tree) {
        result.push(categoryToTreeItem(category));
    }
    return result;
}

function categoryToTreeItem(category: OperatorGetParamsQuestionCategoryOpenApiModel): TreeItemInterface {
    let result: TreeItemInterface = {
        value: category.value,
        label: category.descr
    };
    if (category.children?.length > 0) {
        result.children = [];
        for (let children of category.children) {
            result.children.push(categoryToTreeItem(children));
        }
    }
    return result;
}